import $ from "cash-dom";

export default (function () {
    $(document).ready(function () {
        var selector = "#local-styles";

        if ($(selector).length) {
            var log = typeof debug !== "undefined";
            if (log) console.log("%cfunction_contain.js initialized", "color: green;");

            function setVars() {
                var stylesheet = $(selector)[0];
                var ruleSet = ":root { \n";

                ruleSet += `--viewport-width: ${window.innerWidth / 100}px; \n`;
                ruleSet += `--viewport-height: ${window.innerHeight / 100}px; \n`;
                ruleSet += `--footer-height: ${$("#footer").outerHeight()}px; \n`;

                ruleSet += "}";
                stylesheet.innerHTML = ruleSet;
            }

            setVars();
            $(window).on("resizeEnd", setVars);
        }
    });
})();
